"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("src/app/Services/service.service");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var geolocation_service_1 = require("../../Services/geolocation.service");
var router_1 = require("@angular/router");
var searchroute_service_1 = require("../../Services/searchroute.service");
var environment_1 = require("src/environments/environment");
var SearchResultsComponent = /** @class */ (function () {
    function SearchResultsComponent(service, geolocationService, searchRouteService, advertisementClient, router, route) {
        var _this = this;
        this.service = service;
        this.geolocationService = geolocationService;
        this.searchRouteService = searchRouteService;
        this.advertisementClient = advertisementClient;
        this.router = router;
        this.route = route;
        this._regionShortName = null;
        this._subregionName = null;
        this.breakpoint = 4;
        this._loading = true;
        this.enableSubscription = false;
        this.isPremium = false;
        this.pageSizeOptions = [4, 12, 24, 100]; // index 2 is default
        this.listLayoutType = displayModeType;
        this._listLayout = displayModeType.LIST;
        this.firstSearchPerformed = false;
        this._cardList = null;
        this._currentUserIsAdminUser = null;
        this._currentUserIsDemoUser = null;
        this.enableSubscription = service.enableSubscription;
        this.isPremium = this.service.userService.isPremium();
        this.updateResultList();
        this.service.advService.resultListUpdate.subscribe(function (r) {
            _this._cardList = _this.service.advService.searchDataStandard.resultList;
            _this.loading = false;
        });
        this.searchRouteService.categoryData.subscribe(function (data) {
            _this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId = data.categoryId;
            _this.service.advService.searchDataStandard.currentSearchRule.casualDating = data.casualDating;
            _this.service.advService.performSearchActionWithoutNavigateToSearchResult();
            //this._cardList = this.service.advService.searchDataStandard.resultList;
        });
        this.service.advService.searchInActionChanged.subscribe(function (s) {
            _this.loading = s;
        });
    }
    Object.defineProperty(SearchResultsComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (value) {
            this._loading = value;
        },
        enumerable: true,
        configurable: true
    });
    SearchResultsComponent.prototype.updateResultList = function () {
        this._cardList = this.service.advService.searchDataStandard.resultList;
    };
    Object.defineProperty(SearchResultsComponent.prototype, "showClosestRegionMessage", {
        get: function () {
            return this.ClosestSubregionNameIfNoResult && this.SubregionName != "" && this.RegionName != "" && this.ClosestSubregionNameIfNoResult != this.SubregionName + ", " + this.RegionName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultsComponent.prototype, "ClosestSubregionNameIfNoResult", {
        get: function () {
            return this.service.advService.searchDataStandard.ClosestSubregionNameIfNoResult;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultsComponent.prototype, "length", {
        get: function () {
            return this.service.advService.searchDataStandard.resultCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultsComponent.prototype, "pageSize", {
        get: function () {
            return this.service.advService.searchDataStandard.currentSearchRule.pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultsComponent.prototype, "pageNumber", {
        get: function () {
            return this.service.advService.searchDataStandard.currentSearchRule.pageNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultsComponent.prototype, "SubregionName", {
        get: function () {
            if (this._subregionName != null) {
                return this._subregionName;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchResultsComponent.prototype, "RegionName", {
        get: function () {
            if (this._regionShortName != null) {
                return this._regionShortName;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    SearchResultsComponent.prototype.getAdvertismentImage = function (advertisment) {
        if (advertisment.images.length == 0) {
            return "";
        }
        var image = advertisment.images.find(function (image) { return image.isMain == true; });
        if (image == null) {
            image = advertisment.images[0];
        }
        else {
            image = image[0];
        }
        return image.fileName;
    };
    Object.defineProperty(SearchResultsComponent.prototype, "pageEvent", {
        get: function () {
            return this._pageEvent;
        },
        set: function (value) {
            this.service.advService.searchDataStandard.currentSearchRule.pageNumber = value.pageIndex;
            if (this.pageSizeOptions[2] == value.pageSize)
                this.changeUrlPage(value.pageIndex + 1);
            else
                this.changeUrlPage(value.pageIndex + 1, value.pageSize);
            this.service.advService.searchDataStandard.currentSearchRule.pageSize = value.pageSize;
            this.service.advService.searchAction(false);
            this._pageEvent = value;
        },
        enumerable: true,
        configurable: true
    });
    SearchResultsComponent.prototype.changeUrlPage = function (toPage, pageSize) {
        if (pageSize === void 0) { pageSize = null; }
        var currentUrl = document.location.href;
        var regexPage = /(-page-[0-9]+)/;
        var regexPerPage = /(-per-[0-9]+)/;
        var foundPage = currentUrl.match(regexPage);
        var foundPer = currentUrl.match(regexPerPage);
        var nextUrl = currentUrl;
        if (foundPage)
            nextUrl = nextUrl.replace(regexPage, '-page-' + toPage);
        else
            nextUrl = nextUrl + '-page-' + toPage;
        if (pageSize) {
            if (foundPer)
                nextUrl = nextUrl.replace(regexPerPage, '-per-' + pageSize);
            else
                nextUrl = nextUrl + '-per-' + pageSize;
        }
        var nextState = { additionalInformation: 'next Page ' + toPage + 'page size ' + pageSize };
        window.history.pushState(nextState, document.title, nextUrl);
    };
    Object.defineProperty(SearchResultsComponent.prototype, "listLayout", {
        get: function () {
            return this._listLayout;
        },
        set: function (value) {
            this._listLayout = value;
        },
        enumerable: true,
        configurable: true
    });
    SearchResultsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.service.advService.searchDataStandard.SubregionNameChanged.subscribe(function (value) {
            _this._subregionName = value;
        });
        this.service.advService.searchDataStandard.RegionShortNameChanged.subscribe(function (value) {
            _this._regionShortName = value;
        });
        //this.triggerSearchFromUrl();
        if (window.innerWidth < 576) {
            this.breakpoint = 1;
        }
        else if (window.innerWidth < 992) {
            this.breakpoint = 2;
        }
        else if (window.innerWidth < 1200) {
            this.breakpoint = 3;
        }
        else {
            this.breakpoint = 4;
        }
    };
    SearchResultsComponent.prototype.triggerSearchFromUrl = function () {
        var _this = this;
        var request = new WickedApiClient_1.GetAdvertisementsRequest();
        request.init(this.route.snapshot.params);
        this.advertisementClient.getAdveristmentGetModel(request).toPromise().then(function (response) {
            _this.service.advService.searchDataStandard.currentSearchRule.pageNumber = response.pageNumber;
            _this.service.advService.searchDataStandard.currentSearchRule.regionId = response.regionId;
            _this.service.advService.searchDataStandard.currentSearchRule.subRegionId = response.subRegionId;
            _this.service.advService.searchDataStandard.currentSearchRule.casualDating = response.casualDating;
            _this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId = response.advertisementCategoryId;
            _this.service.advService.searchDataStandard.currentSearchRule.withPicturesOnly = response.withPicturesOnly;
            _this.service.advService.searchAction();
        });
    };
    SearchResultsComponent.prototype.ngOnDestroy = function () {
    };
    SearchResultsComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth < 576) {
            this.breakpoint = 1;
        }
        else if (event.target.innerWidth < 992) {
            this.breakpoint = 2;
        }
        else if (event.target.innerWidth < 1200) {
            this.breakpoint = 3;
        }
        else {
            this.breakpoint = 4;
        }
    };
    Object.defineProperty(SearchResultsComponent.prototype, "cardList", {
        get: function () {
            return this._cardList;
        },
        enumerable: true,
        configurable: true
    });
    SearchResultsComponent.prototype.getLocation = function (adv) {
        return adv.subRegionName + ", " + adv.regionShortName;
    };
    SearchResultsComponent.prototype.getAdvDate = function (adv) {
        if (adv.dateStart != null) {
            return adv.dateStart.format("MM/DD/YYYY");
        }
        else
            return "";
    };
    SearchResultsComponent.prototype.getAdvTag = function (adv) {
        var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : "[" + adv.categoryCode + "] ";
        return "" + tag;
    };
    SearchResultsComponent.prototype.getAdvTitle = function (adv) {
        return "" + adv.title;
    };
    SearchResultsComponent.prototype.getImageFromCard = function (card) {
        if (card.images.length > 0) {
            var mainImage = card.images.filter(function (v) { return v.isMain == true; });
            if (mainImage.length > 0) {
                return environment_1.environment.apiBaseUrl + "/FileGet/" + mainImage[0].fileName + "/300x700";
            }
            else {
                return environment_1.environment.apiBaseUrl + "/FileGet/" + card.images[0].fileName + "/300x700";
            }
        }
        else {
            return environment_1.environment.apiBaseUrl + "/images/placeholder.jpg";
        }
    };
    SearchResultsComponent.prototype.hasAdvertismentImage = function (advertisment) {
        return advertisment.images.length > 0;
    };
    SearchResultsComponent.prototype.currentUserIsAdminUser = function () {
        if (this._currentUserIsAdminUser == null) {
            this._currentUserIsAdminUser = this.service.userService.isAuthenticated() && this.service.userService.isAdmin();
        }
        return this._currentUserIsAdminUser;
    };
    SearchResultsComponent.prototype.currentUserIsDemoUser = function () {
        if (this._currentUserIsDemoUser == null) {
            this._currentUserIsDemoUser = this.service.userService.isAuthenticated() && this.service.userService.isDemo();
        }
        return this._currentUserIsDemoUser;
    };
    SearchResultsComponent.prototype.openAdv = function (id) {
        this.service.route.navigate(["adv-detail/" + id]);
    };
    SearchResultsComponent.prototype.getPremiumText = function (advertisement) {
        if (advertisement.showAs == WickedApiClient_1.ShowAdType.PremiumAd) {
            return "Premium Ad";
        }
        else if (advertisement.showAs == WickedApiClient_1.ShowAdType.PremiumUser) {
            return "Premium User";
        }
        else if (advertisement.isPremium) {
            if (advertisement.isPremiumUser) {
                return "Premium User";
            }
            else {
                return "Premium Ad";
            }
        }
        return "";
    };
    SearchResultsComponent.prototype.openImageMenu = function (trigger) {
        trigger.openMenu();
    };
    SearchResultsComponent.prototype.closeImageMenu = function (trigger) {
        trigger.closeMenu();
    };
    SearchResultsComponent.prototype.isSeen = function (card) {
        if (!this.currentUserIsAdminUser()) {
            return true;
        }
        if (card.isDemo) {
            return true;
        }
        if (this.currentUserIsAdminUser() && card.seenAdmin) {
            return true;
        }
        if (this.currentUserIsDemoUser() && card.seen) {
            return true;
        }
        return false;
    };
    SearchResultsComponent.prototype.pageChange = function (e) {
        window.scroll(0, 0);
    };
    return SearchResultsComponent;
}());
exports.SearchResultsComponent = SearchResultsComponent;
var displayModeType;
(function (displayModeType) {
    displayModeType["ROW"] = "_layoutROW";
    displayModeType["LIST"] = "_layoutLIST";
    displayModeType["TILE"] = "_layoutTile";
    displayModeType["GRID"] = "_layoutGrid";
})(displayModeType = exports.displayModeType || (exports.displayModeType = {}));
